export const preparePathWithSlash = (path = '') => {
  const isPathAlreadyWithSlash = path.slice(-1) === '/';
  const isPathWithHash = path.includes('#');
  if (isPathAlreadyWithSlash || isPathWithHash) {
    return path;
  }
  return `${path}/`;
}